import { useState, useEffect } from 'react'

function MobileMenu({ activeTab, setActiveTab, tabs, onLogout, unreadCount }) {
  const [isOpen, setIsOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  // Check screen size on mount and resize
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  const toggleMenu = () => setIsOpen(!isOpen)
  
  const closeMenu = () => setIsOpen(false)

  // Don't render mobile menu on desktop
  if (!isMobile) return null

  return (
    <>
      {/* Mobile Header */}
      <div style={mobileHeaderStyle}>
        <div style={logoStyle}>
          <span>🏢 EstatesFlow</span>
        </div>
        <button onClick={toggleMenu} style={menuButtonStyle}>
          ☰
        </button>
      </div>

      {/* Mobile Sidebar Overlay */}
      {isOpen && (
        <>
          <div style={overlayStyle} onClick={closeMenu} />
          <div style={mobileSidebarStyle}>
            <div style={sidebarHeaderStyle}>
              <h3 style={{ margin: 0, color: '#fff' }}>Menu</h3>
              <button onClick={closeMenu} style={closeBtnStyle}>✕</button>
            </div>
            
            {/* Unread messages badge in header */}
            {unreadCount > 0 && (
              <div style={unreadBadgeStyle}>
                💬 {unreadCount} unread message{unreadCount !== 1 ? 's' : ''}
              </div>
            )}
            
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => {
                  setActiveTab(tab.id)
                  closeMenu()
                }}
                style={activeTab === tab.id ? mobileActiveTabStyle : mobileTabStyle}
              >
                <span style={{ marginRight: '10px' }}>{tab.icon}</span>
                {tab.label}
              </button>
            ))}
            
            <button onClick={onLogout} style={logoutButtonStyle}>
              🚪 Logout
            </button>
          </div>
        </>
      )}
    </>
  )
}

// Styles
const mobileHeaderStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  background: 'linear-gradient(135deg, #1e3a5f 0%, #0f2b42 100%)',
  color: '#fff',
  padding: '15px 20px',
  zIndex: 999,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
}

const logoStyle = {
  fontSize: '18px',
  fontWeight: 'bold'
}

const menuButtonStyle = {
  background: 'none',
  border: 'none',
  color: '#fff',
  fontSize: '24px',
  cursor: 'pointer',
  padding: '5px 10px'
}

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0,0,0,0.5)',
  zIndex: 1000
}

const mobileSidebarStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  width: '280px',
  background: 'linear-gradient(135deg, #1e3a5f 0%, #0f2b42 100%)',
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  overflowY: 'auto',
  zIndex: 1001,
  animation: 'slideIn 0.3s ease'
}

const sidebarHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
  paddingBottom: '15px',
  borderBottom: '1px solid rgba(255,255,255,0.1)',
  color: '#fff'
}

const closeBtnStyle = {
  background: 'none',
  border: 'none',
  color: '#fff',
  fontSize: '20px',
  cursor: 'pointer',
  padding: '5px'
}

const unreadBadgeStyle = {
  background: '#dc2626',
  color: '#fff',
  padding: '8px 12px',
  borderRadius: '20px',
  fontSize: '12px',
  marginBottom: '15px',
  textAlign: 'center'
}

const mobileTabStyle = {
  background: 'rgba(255,255,255,0.08)',
  border: 'none',
  padding: '12px 16px',
  borderRadius: 10,
  color: '#fff',
  fontSize: 14,
  cursor: 'pointer',
  textAlign: 'left',
  fontWeight: 500,
  width: '100%',
  transition: 'background 0.2s'
}

const mobileActiveTabStyle = {
  ...mobileTabStyle,
  background: '#2c7da0',
  boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
}

const logoutButtonStyle = {
  ...mobileTabStyle,
  marginTop: '20px',
  background: '#dc2626',
  color: '#fff'
}

// Add animation styles
const style = document.createElement('style')
style.textContent = `
  @keyframes slideIn {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }
  
  @media (max-width: 768px) {
    /* Hide desktop sidebar on mobile */
    .desktop-sidebar {
      display: none !important;
    }
    
    /* Adjust main content for mobile header */
    .portal-main {
      margin-top: 60px !important;
      padding-top: 0 !important;
    }
  }
`
document.head.appendChild(style)

export default MobileMenu